// Tabla 17 - Estado del contrato
// TransUnion - Tablas de convenciones - Información Comercial - Versión 1.34

const estadoContrato = {
  VIGE: 'Vigente',
  NVIG: 'No vigente'
};

export default estadoContrato;
